<template>
  <div class="header-bar" id="header-bar">

    <span class="header-bar_image" v-on:click="goHome"></span>

    <span class="header-bar_links">
      <!-- <router-link :to="'/about'" v-on:click="resetScroll('about')" class="header-bar_link">about</router-link> -->
      <!-- <a href="http://mikmak.tv#attach" v-on:click="resetScroll('platform')" class="header-bar_link">platform</a> -->
      <button class="header-bar_link header-bar_button" name="button">
        Industries
        <div class="header-bar_button-submenu">
          <a v-for="industry in industries" :href="industry.link">{{ industry.title }}</a>
        </div>
      </button>
      <button class="header-bar_link header-bar_button" name="button">
        Solutions
        <div class="header-bar_button-submenu">
          <a v-for="solution in solutions" :href="solution.link">{{ solution.title }}</a>
        </div>
      </button>
      <a href="http://mikmak.tv#studios" v-on:click="resetScroll('studios')" class="header-bar_link">studios</a>
      <a href="http://mikmak.tv#press" v-on:click="resetScroll('press')" class="header-bar_link">press</a>
      <a href="http://mikmak.tv#contact" v-on:click="resetScroll('contact')" class="header-bar_link header-bar_contact-link">contact</a>
    </span>

    <img v-on:click="goHome" src="../assets/mikmak-logo-white-new.png" alt="mikmak" class="mobile-logo" v-bind:class="[mobileMenuVisible ? 'mobile-logo-visible' : 'mobile-logo-hidden']">
    <span class="header-toggle-mobile" v-on:click="toggleMobileMenu">
      <label class="toggle-bar-top" v-bind:class="[mobileMenuVisible ? 'top-tilt' : '']"></label>
      <label class="toggle-bar-middle" v-bind:class="[mobileMenuVisible ? 'middle-hidden' : '']"></label>
      <label class="toggle-bar-bottom" v-bind:class="[mobileMenuVisible ? 'bottom-tilt' : '']"></label>
    </span>

    <span class="mobile-menu" v-bind:class="[mobileMenuVisible ? 'visible' : 'hidden']">
      <!-- <router-link :to="'/about'" v-on:click="resetScroll('about')" class="header-bar_link-mobile">about</router-link> -->
      <!-- <a href="http://mikmak.tv#attach" class="header-bar_link-mobile" v-on:click="hideMobileMenu('platform')">platform</a> -->

      <button class="header-bar_link-mobile header-bar_button" name="button" v-on:click="showMobileIndustries = !showMobileIndustries">
        Industries
        <div class="header-bar_button-mobile-submenu" v-show="showMobileIndustries">
          <a v-for="industry in industries" :href="industry.link">{{ industry.title }}</a>
        </div>
      </button>

      <button class="header-bar_link-mobile header-bar_button" name="button" v-on:click="showMobileSolutions = !showMobileSolutions">
        Solutions
        <div class="header-bar_button-mobile-submenu" v-show="showMobileSolutions">
          <a v-for="solution in solutions" :href="solution.link">{{ solution.title }}</a>
        </div>
      </button>

      <a href="http://mikmak.tv#studios" class="header-bar_link-mobile" v-on:click="hideMobileMenu('studios')">studios</a>
      <a href="http://mikmak.tv#press" class="header-bar_link-mobile" v-on:click="hideMobileMenu('press')">press</a>
      <a href="http://mikmak.tv#contact" class="header-bar_link-mobile" v-on:click="hideMobileMenu('contact')">contact</a>
    </span>


  </div>
</template>

<script>

import eventDispatcher from '../events/dispatch'

const scrollListener = () => {
  if (window.pageYOffset >= 10) {
    setHeaderClass('header-bar scrolled')
  } else {
    setHeaderClass('header-bar')
  }
}

const setHeaderClass = (className) => {
  document.getElementById('header-bar').className = className
}

export default {
  data() {
    return {
      mobileMenuVisible: false,
      showMobileSolutions: false,
      showMobileIndustries: false
    }
  },
  mounted() {
    this.resetScroll()
    window.document.onscroll = scrollListener
  },
  methods: {
    goHome() {
      window.location = '/'
    },
    toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible
    },
    hideMobileMenu(pageName) {
      this.linkClickEvent(pageName)
      this.mobileMenuVisible = false
      this.resetScroll()
    },
    resetScroll(pageName) {
      this.linkClickEvent(pageName)
      setTimeout(() => {
        window.scrollBy(0, -48)
      }, 10)
    },
    linkClickEvent(pageName) {
      if (!pageName) return
      eventDispatcher('headerLinkClicked', {
        page: pageName
      })
    }
  },
  computed: {
    links() {
      return this.$store.state.headerLinks
    },
    solutions() {
      return this.$store.state.solutionsAndIndustries.solutions
    },
    industries() {
      return this.$store.state.solutionsAndIndustries.industries
    }
  },
  watch: {}
}
</script>

<style scoped scss>

  .header-bar {
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    white-space: nowrap;
    border-top: 2px solid #00BFBD;
    z-index: 4;
    transition: ease-in 0.125s;
    /* background: #00BFBD; */
  }

  .header-bar.scrolled {
    background: white;
    box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.06);
    transition: ease-in 0.0125s;
  }

  @media only screen and (max-width: 650px) {
    .header-bar {
      border-top: 4px solid #00BFBD;
    }
  }

  .header-bar .header-bar_image {
    background-image: url('../assets/mikmak-logo-new.png')
  }

  .header-bar.scrolled .header-bar_image {
    background-image: url('../assets/mikmak-logo-new.png')
  }

  .header-bar .header-bar_link {
    color: #00BFBD;
  }

  .header-bar.scrolled .header-bar_link {
    color: #00BFBD;
  }

  .header-bar_link {
    -webkit-appearance: none;
    background: none;
    border: none;
    cursor: pointer;
    font-family: 'Work Sans', sans-serif;
    display: inline-block;
    text-decoration: none;
    font-weight: normal;
    font-size: 16px;
    margin: 8px;
    text-transform: lowercase;
    letter-spacing: 2px;
    outline: none;
  }

  .header-bar_image {
    display: block;
    padding-top: 12px;
    padding-left: 24px;
    width: 49%;
    background-repeat: no-repeat;
    height: 48px;
    background-size: 85px;
    background-position: 24px 12px;
  }

  @media only screen and (max-width: 650px) {
    .header-bar_image {
      background-position: 12px;
    }
  }

  .header-bar_image img {
    height: 42px;
    padding-bottom: 8px;
  }

  @media only screen and (max-width: 650px) {
    .header-bar_image img {
      height: 24px;
    }
  }

  .header-bar_links {
    position: fixed;
    right: 0;
    text-align: right;
    top: 0;
    padding: 6px 24px;
  }

  @media only screen and (max-width: 650px) {
    .header-bar_links {
      display: none;
    }
  }

  .mobile-menu {
    display: block;
    transition: ease-in 0.125s;
    position: fixed;
    background: #00BFBD;
    width: 100%;
    bottom: 0;
    top: 0px;
    padding-top: 72px;
    overflow: scroll;
  }

  .header-toggle-mobile {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    display: block;
    position: fixed;
    z-index: 10;
    top: 16px;
    right: 12px;
  }

  .header-toggle-mobile label {
    display: block;
    width: 48px;
    height: 6px;
    margin: 4px;
    border-radius: 100px;
    pointer-events: none;
    transition: ease-in 0.125s;
  }

  .header-bar .header-toggle-mobile label {
    background: #00BFBD;
  }

  .header-bar.scrolled .header-toggle-mobile label {
    background: #00BFBD;
  }

  .mobile-menu.visible {
    right: 0;
  }

  .mobile-menu.hidden {
    right: -1200px;
  }

  .header-bar_link-mobile {
    font-family: 'Work Sans', sans-serif;
    display: block;
    text-decoration: none;
    font-weight: lighter;
    text-transform: lowercase;
    font-size: 48px;
    width: 100%;
    text-align: center;
    padding: 12px 0;
    color: white;
    -webkit-appearance: none;
    background: none;
    border: none;
    outline: none;
  }

  @media only screen and (min-width: 650px) {
    .mobile-menu,
    .header-toggle-mobile {
      display: none;
      visibility: hidden;
    }
  }

  .top-tilt {
    transform: rotate(-45deg);
    margin-top: 12px !important;
    background: white !important;
  }

  .bottom-tilt {
    transform: rotate(45deg);
    margin-top: -19px !important;
    background: white !important;
  }

  .middle-hidden {
    opacity: 0;
  }

  .mobile-logo {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    display: block;
    position: fixed;
    left: 12px;
    top: 17px;
    z-index: 20;
    width: 86px;
    transition: ease-in 0.125s;
    cursor: pointer;
  }

  .mobile-logo-visible {
    opacity: 1;
  }

  .mobile-logo-hidden {
    opacity: 0;
  }

  .header-bar_contact-link {
    background: #409dd4;
    background: #00a9bc;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    color: white !important;
    padding: 4px 15px;
    border-radius: 4px;
    box-shadow: 0 2px 2px #00000014;
  }

  .header-bar_button {
    padding-bottom: 24px;
  }

  .header-bar_button .header-bar_button-submenu {
    display: none;
  }

  .header-bar_button:hover .header-bar_button-submenu {
    display: block;
    text-align: left;
    position: absolute;
    background: white;
    border: 1px solid #00BFBD;
    padding: 0 8px;
    margin: 4px 0;
    border-radius: 4px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.11);
  }

  .header-bar_button-submenu a {
    display: block;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 14px;
    color: #14a09f;
    margin: 8px 2px;
  }

  .header-bar_button-submenu a:hover {
    text-decoration: underline;
  }

  .header-bar_button-mobile-submenu a {
    display: block;
    font-size: 30px;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin: 12px;
    color: white;
    opacity: 0.6;
    white-space: normal;
  }

</style>



// WEBPACK FOOTER //
// HeaderBar.vue?0cb7a8e5